import React, { useState } from "react";
import { pumpStatusColor, riskColor, MiniBar, PumpBadge } from "./stpHelpers";

const StpPumpPanel = ({ d }) => {
  const [selected, setSelected] = useState(null);
  const sel = selected ? d.pumps.find(p => p.id === selected) : null;
  const selSt = sel ? pumpStatusColor(sel.status) : null;

  return (
    <div className="stp-pump-panel">
      <div className="stp-pump-summary">
        {[
          { label: "Running",  count: d.pumps.filter(p => p.status === "Running").length,  color: "#10b981" },
          { label: "Standby",  count: d.pumps.filter(p => p.status === "Standby").length,  color: "#3b82f6" },
          { label: "Idle",     count: d.pumps.filter(p => p.status === "Idle").length,     color: "#6b7280" },
          { label: "High Risk",count: d.pumps.filter(p => p.failureRisk >= 30).length,     color: "#ef4444" },
        ].map(s => (
          <div key={s.label} className="stp-ps-card" style={{ borderTopColor: s.color }}>
            <div className="stp-ps-val" style={{ color: s.color }}>{s.count}</div>
            <div className="stp-ps-lbl">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="stp-pump-body">
        {/* Pump list */}
        <div className="stp-pump-list">
          {d.pumps.map(p => {
            const st = pumpStatusColor(p.status);
            const rc = riskColor(p.failureRisk);
            return (
              <div key={p.id} className={`stp-pump-card ${p.id === selected ? "stp-pump-sel" : ""}`}
                onClick={() => setSelected(p.id === selected ? null : p.id)}
                style={{ borderLeftColor: st.color }}>
                <div className="stp-pc-top">
                  <div>
                    <div className="stp-pc-id">{p.id}</div>
                    <div className="stp-pc-name">{p.name}</div>
                    <div className="stp-pc-type">{p.type} Pump</div>
                  </div>
                  <PumpBadge status={p.status} />
                </div>
                <div className="stp-pc-stats">
                  <span>⏱ {p.runHours}h</span>
                  {p.current > 0 && <span>⚡ {p.current}A</span>}
                  {p.power > 0 && <span>🔋 {p.power}kW</span>}
                </div>
                <div className="stp-pc-risk-row">
                  <span style={{ fontSize: 11, color: rc }}>Failure risk: {p.failureRisk}%</span>
                  <MiniBar value={p.failureRisk} max={100} color={rc} height={5} />
                </div>
                <div className="stp-pc-maint">🔧 Next maintenance: {p.nextMaintenance}</div>
              </div>
            );
          })}
        </div>

        {/* Detail */}
        {sel ? (
          <div className="stp-pump-detail">
            <div className="stp-pd-header" style={{ borderColor: selSt.color }}>
              <div>
                <div className="stp-pd-id">{sel.id} — {sel.name}</div>
                <div className="stp-pd-type">{sel.type} Pump</div>
              </div>
              <PumpBadge status={sel.status} />
            </div>
            <div className="stp-pd-readings">
              {[
                { label: "Run Hours Today",  value: `${sel.runHours}h` },
                { label: "Current Draw",     value: sel.current > 0 ? `${sel.current} A` : "Off" },
                { label: "Power",            value: sel.power > 0 ? `${sel.power} kW` : "Off" },
                { label: "Vibration",        value: sel.vibration != null ? `${sel.vibration} mm/s` : "N/A" },
                { label: "Efficiency",       value: sel.efficiency != null ? `${sel.efficiency}%` : "N/A" },
                { label: "Failure Risk",     value: `${sel.failureRisk}%`, color: riskColor(sel.failureRisk) },
                { label: "Next Maintenance", value: sel.nextMaintenance },
              ].map(r => (
                <div key={r.label} className="stp-pd-reading">
                  <div className="stp-pdr-val" style={{ color: r.color || "#1f2937" }}>{r.value}</div>
                  <div className="stp-pdr-lbl">{r.label}</div>
                </div>
              ))}
            </div>
            {sel.failureRisk >= 30 && (
              <div className="stp-pd-ai">
                🤖 AI: Failure risk is {sel.failureRisk}% — {sel.failureRisk >= 42 ? "schedule immediate inspection" : "monitor closely, schedule service within 1 week"}.
              </div>
            )}
            {sel.efficiency != null && (
              <div style={{ marginTop: 10 }}>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Efficiency trend</div>
                <MiniBar value={sel.efficiency} max={100} color={sel.efficiency > 85 ? "#10b981" : "#f59e0b"} height={8} />
              </div>
            )}
          </div>
        ) : (
          <div className="stp-pump-no-sel">
            <div style={{ fontSize: 32 }}>⚙</div>
            <div>Select a pump to view details</div>
          </div>
        )}
      </div>

      <div className="stp-ai-strip">
        🤖 AI: Recirculation pump P-04 shows 42% failure risk. Overdue by 2 days. Schedule maintenance immediately to prevent unplanned plant downtime.
      </div>
    </div>
  );
};

export default StpPumpPanel;
